import React, { useState } from "react";
import {
  decrypt,
  encrypt,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import { Link, Outlet, useNavigate } from "react-router-dom";
import AuthBg from "./AuthBg";
import * as Yup from "yup";
import { useFormik } from "formik";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import ClipLoader from "react-spinners/ClipLoader";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import { ToastContainer } from "react-toastify";
import { getCookie, setCookie } from "../../helpers/CookieComponent";

const onlyIntRegExp = /^[0-9+]+$/;
const onlyAlphabet = /^[A-Za-z][A-Za-z\s]+$/;

// Formik InitialValues
const initialValues = {
  // userName: "",
  email: "",
  mobileNumber: "",
  password: "",
  confirmPassword: "",
  referCode: "",
};

// Fromik Validation Schema
const schema = Yup.object().shape({
  // userName: Yup.string().trim().required("User name is required"),
  email: Yup.string()
    .trim()
    .required("Email is required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email is not valid"
    ),
  mobileNumber: Yup.string()
    .trim()
    .required("Mobile number is required")
    .matches(onlyIntRegExp, "Mobile number is not valid")
    .min(10, "Mobile number is not valid")
    .max(16, "Mobile number is not valid"),
  password: Yup.string()
    // .matches(
    //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/,
    //   "Password Must Be At Least 12 Characters Long, Include One Uppercase Letter, One Lowercase Letter, One Number, And One Special Character"
    // )
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()?"])[A-Za-z\d!@#$%^&*()?"]{12,}$/,
      "Please ensure your password is at least 12 characters long and includes a mix of uppercase and lowercase letters, numbers, and special characters (! “ ? $ % ^ &).Avoid using common words, personal information, or easily guessed patterns"
    )
    .required("Password is required"),
  confirmPassword: Yup.string()
    .required("Confirm password is Required")
    .oneOf([Yup.ref("password")], "Password must match"),
  referCode: Yup.string().trim(),
});

const Register = () => {
  const [loading, setLoading] = useState(false);
  const [isPasswordShow, setIsPasswordShow] = useState(false);
  const [isConfirmPasswordShow, setIsConfirmPasswordShow] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        // userName: values.userName,
        email: values.email,
        mobileNumber: values.mobileNumber,
        password: values.password,
        referCode: values.referCode,
      };

      const response = await postData("user/register", param, apiHeader(false));
      console.log(response);

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoading(false);
          navigate("/otpverify", {
            state: {
              userId: response.data.data.userId,
              userName: values.email,
            },
          });
          resetForm();
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  return (
    <>
      <ToastContainer />
      <div className="flex flex-col lg:flex-row lg:justify-end lg:min-h-[85vh] xl:min-h-screen h-max">
        {/* Background Section */}
        <div className="h-auto lg:h-screen z-[1] relative lg:fixed top-0 left-0 lg:w-[40%]">
          <AuthBg />
        </div>
        <div className="lg:w-[60%] py-[5%] px-[5%] md:px-[10%] bg-yellow">
          <div className="flex flex-col lg:flex-row w-full p-10">
            <div className="flex items-center justify-center flex-col lg:flex-row w-full">
              <div className="w-full lg:w-[500px]">
                <h1 className="mb-4 auth-title-y">Register</h1>
                <p className="mb-[5%] auth-text-g">
                  Already user?{" "}
                  <Link to="/login" className="auth-text-b">
                    Log in
                  </Link>
                </p>
                <form onSubmit={formik.handleSubmit}>
                  <div className="w-full flex flex-col gap-[2rem] mb-[7rem]">
                    {/* <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full auth-input-label mb-4 required"
                      >
                        User name
                      </label>
                      <input
                        className="w-full auth-input"
                        type="text"
                        placeholder="Enter user name"
                        id="userName"
                        value={formik.values.userName}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.userName && formik.errors.userName && (
                        <div className="mt-2 error-msg">
                          <div className="">{formik.errors.userName}</div>
                        </div>
                      )}
                    </div> */}
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full auth-input-label mb-4 required"
                      >
                        Email
                      </label>
                      <input
                        className="w-full auth-input"
                        type="email"
                        placeholder="Enter email"
                        id="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.email && formik.errors.email && (
                        <div className="mt-2 error-msg">
                          <div className="">{formik.errors.email}</div>
                        </div>
                      )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full auth-input-label mb-4 required"
                      >
                        Mobile number
                      </label>
                      <input
                        className="w-full auth-input"
                        type="text"
                        placeholder="Enter mobile number"
                        id="mobileNumber"
                        value={formik.values.mobileNumber}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.mobileNumber &&
                        formik.errors.mobileNumber && (
                          <div className="mt-2 error-msg">
                            <div className="">{formik.errors.mobileNumber}</div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full auth-input-label mb-4 required"
                      >
                        Password
                      </label>
                      <div className="w-full relative">
                        <input
                          className="w-full auth-input"
                          type={isPasswordShow ? "text" : "password"}
                          placeholder="Enter password"
                          id="password"
                          value={formik.values.password}
                          onChange={formik.handleChange}
                        />
                        {isPasswordShow == true ? (
                          <FaEyeSlash
                            onClick={() => setIsPasswordShow(false)}
                            className="absolute cursor-pointer top-[2rem] right-[2.5rem] auth-input-eye"
                          />
                        ) : (
                          <FaEye
                            onClick={() => setIsPasswordShow(true)}
                            className="absolute cursor-pointer top-[2rem] right-[2.5rem] auth-input-eye"
                          />
                        )}
                      </div>
                      {formik.touched.password && formik.errors.password && (
                        <div className="mt-2 error-msg">
                          <div className="">{formik.errors.password}</div>
                        </div>
                      )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full auth-input-label mb-4 required"
                      >
                        Confirm password
                      </label>
                      <div className="w-full relative">
                        <input
                          className="w-full auth-input"
                          type={isConfirmPasswordShow ? "text" : "password"}
                          placeholder="Enter confirm password"
                          id="confirmPassword"
                          value={formik.values.confirmPassword}
                          onChange={formik.handleChange}
                        />
                        {isConfirmPasswordShow == true ? (
                          <FaEyeSlash
                            onClick={() => setIsConfirmPasswordShow(false)}
                            className="absolute cursor-pointer top-[2rem] right-[2.5rem] auth-input-eye"
                          />
                        ) : (
                          <FaEye
                            onClick={() => setIsConfirmPasswordShow(true)}
                            className="absolute cursor-pointer top-[2rem] right-[2.5rem] auth-input-eye"
                          />
                        )}
                      </div>
                      {formik.touched.confirmPassword &&
                        formik.errors.confirmPassword && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formik.errors.confirmPassword}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col mb-4">
                      <label
                        htmlFor=""
                        className="w-full auth-input-label mb-4"
                      >
                        Refer code
                      </label>
                      <input
                        className="w-full auth-input"
                        type="text"
                        placeholder="Enter refer code"
                        id="referCode"
                        value={formik.values.referCode}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.referCode && formik.errors.referCode && (
                        <div className="mt-2 error-msg">
                          <div className="">{formik.errors.referCode}</div>
                        </div>
                      )}
                    </div>
                    <p className="mb-5 auth-text-g">
                      {/* Hint: The password should be at least twelve characters
                      long. To make it stronger,use upper and lower case
                      letters, numbers, and symbols like ! " ? $ % ^ & {")"}. */}
                      Hint: The password should be at least twelve characters
                      long. It must have upper and lower case letters, numbers,
                      and symbols like ! " ? $ % ^ & {")"}.
                    </p>
                    <p className="auth-text-g">
                      Your personal data will be used to support your experience
                      throughout this website, to manage access to your account,
                      and for other purposes described in our privacy policy.
                    </p>
                  </div>
                  <div className="w-full justify-center lg:justify-start gap-5 flex">
                    <button
                      type="submit"
                      className="btn-auth"
                      disabled={loading}
                    >
                      {!loading && <>Register</>}
                      {loading && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Register;
